import React, { useRef, useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Tab,
  Nav,
  Card,
  CardBody,
  Form,
  Accordion,
} from "react-bootstrap";
import { useParams } from 'react-router-dom';

import SearchableDropdown from "../../Component/SearchableDropdown";
import Attachments from "../../Component/TemplateAttachments";

import Header from "../../Component/Header";
import placeholderImg from "../../Asset/Images/circle-placeholder.svg";
import placeholderImgLarge from "../../Asset/Images/placeholder-large-icon.png";
import plusIcon from "../../Asset/Images/plus-icon.svg";
import deleteIcon from "../../Asset/Images/delete-icon.svg";
import attachmentIcon from "../../Asset/Images/attachment-icon.svg";
import downArrowIcon from "../../Asset/Images/down-arrow-icon.svg";
import crossIcon from "../../Asset/Images/cross-icon.svg";
import messageIcon from "../../Asset/Images/message-icon.svg";
import checkIcon from "../../Asset/Images/check-circle-green-icon.svg";
import crossIconWeb from "../../Asset/Images/crose-grey-circle-icon.svg";
import uploadIcon from "../../Asset/Images/upload-img-icon.svg";
import SubHeader from "../../Component/SubHeader";
import Modal from "react-bootstrap/Modal";
import FullScreenLoader from "../../Component/Loader";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import MobileFooter from "../../Component/MobileFooter";


import { postDeploy, getParts, uploadImg, getLocations, getEmails, getRequestById, updateStatus, updateRequest, deleteAsset } from "../../Services/deploy";

import "./index.css";

// ---- Shared allowed image MIME types ----
const ALLOWED_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/webp",
  "image/gif",
];
const ALLOWED_IMAGE_ACCEPT = "image/png, image/jpeg, image/jpg, image/webp, image/gif";

function Add() {
  const { templateId } = useParams();
  let navigate = useNavigate();
  const fileInputRefs = useRef([]);
  const additionalFileInputRefs = useRef([]);
  const vehicleFrontRef = useRef(null);
  const vehicleBackRef = useRef(null);
  const vehicleSide1Ref = useRef(null);
  const vehicleSide2Ref = useRef(null);
  const [show, setShow] = useState(false);
  const [additionalForm, setAdditionalForm] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null);
  const [selectedPreviewAdditional, setSelectedPreviewAdditional] =
    useState(null);
  const [vehicleFrontimage, setVehicleFrontimage] = useState(null);
  const [vehicleBackimage, setVehicleBackimage] = useState(null);
  const [vehicleFrontName, setVehicleFrontName] = useState(null);
  const [vehicleBackName, setVehicleBackName] = useState(null);

  const [vehicleside1image, setVehicleside1image] = useState(null);
  const [vehicleside2image, setVehicleside2image] = useState(null);
  const [vehicleFrontPreview, setVehicleFrontPreview] = useState(null);
  const [vehicleBackPreview, setVehicleBackPreview] = useState(null);
  const [vehicleside1Preview, setVehicleside1Preview] = useState(null);
  const [vehicleside2Preview, setVehicleside2Preview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [partsList, setPartsList] = useState([]);
  const [assetType, setAssetType] = useState(1);
  const [additionalEmail, setAdditionalEmail] = useState('');
  const [additionalEmailError, setAdditionalEmailError] = useState("");
  const [additionalEmails, setAdditionalEmails] = useState([]);

  const [inputOptionList, setInputOptionList] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [status, setStaus] = useState('');
  const [additionalEmailsList, setAdditionalEmailsList] = useState([]);

  // ---- Vehicle preview modal state ----
  const [showVehiclePreview, setShowVehiclePreview] = useState(false);
  const [vehiclePreviewSrc, setVehiclePreviewSrc] = useState(null);
  const [vehiclePreviewName, setVehiclePreviewName] = useState("");



  const [formData, setFormData] = useState({
    rigNuber: "",
    laydown: "",
    reason: "",
    comingfrom: "",
    note: ""
  });

  const [truckingToRig, setTruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  const [additionaltruckingToRig, setAdditionaltruckingToRig] = useState({
    company: "",
    driverName: "",
    phone: "",
    bol: "",
    payforTruck: "",
    po: "",
  });

  let [assests, setAssets] = useState([
    {
      id: 0,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      value: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Coming_From: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    },
  ]);

  let [additionalAsset, setAdditionalAsset] = useState([
    {
      id: 0,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      from: "",
      value: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    },
  ]);

  const heading = "ADD: Basin/Laydown-Yard => Rig/Jobsite Shipments";

  // ---- Central lock flag ----
  const isAdmin = localStorage.role === "Admin";
  const isCompleted = status === "Completed";
  const isLocked = templateId ? (!isAdmin || isCompleted) : false;
  // Assets must remain read-only whenever this Add request is opened in edit mode.
  const areAssetsLocked = Boolean(templateId) || isLocked;

  useEffect(() => {
    fetchParts();
    fetchEmail()
    if (templateId) {
      fetchRequestDetails()
    }
  }, []);


  let handleComplete = async () => {
    if (isLocked) return;
    let payload = {
      "RequestID": templateId,
      "Status": "Completed"
    }
    setIsLoading(true)
    let res = await updateStatus(payload, localStorage.access_token)
    setIsLoading(false)
    if (res.data && res.status == 200) {
      toast.success(res.data)
      fetchRequestDetails()
    }
  }

  let fetchRequestDetails = async () => {
    let payload = {
      ID: templateId
    }
    let res = await getRequestById(payload, localStorage.access_token)
    if (res.status == 200) {
      let data = res.data.RequestDetails
      setStaus(data?.Status)
      setFormData({
        rigNuber: data?.JobSiteNumber,
        laydown: data?.ShippedFrom,
        reason: data?.ADDED_Because,
        note: data?.Note,
        comingfrom: "",
      })

      setTruckingToRig({
        company: data?.Company,
        driverName: data?.DriverName,
        phone: data?.PhoneNumber,
        bol: data?.BOL,
        payforTruck: data?.PayForTruck,
        po: data?.S3SPO,
      })
      setAdditionalEmailsList(data?.additional_email_recipients?.length ? data?.additional_email_recipients : [])
      setVehicleFrontPreview(data?.VehicleFrontBlob)
      setVehicleBackPreview(data?.VehicleBackBlob)
      setAdditionalEmails(data?.additional_email_recipients)


      let assetTemp = []
      data?.Asset?.map((ast, i) => {
        let obj = {
          id: `${Date.now()}-${i}`,
          name: "S3S",
          ID: ast?.ID,
          img: ast?.AssetBlob,
          imgName: ast?.AssetBlob.substring(0, 10),
          imgPreview: ast?.AssetBlob,
          value: "",
          AssetID: ast?.AssetID,
          AssetNo: ast?.AssetNo,
          AssetBlob: ast?.AssetBlob,
          Coming_From: ast?.Coming_From,
          Broken_AssetID: "",
          Broken_AssetNo: "",
          Broken_AssetBlob: "",
        }
        assetTemp.push(obj)
      })
      setAssets(assetTemp)

    }
  }

  let fetchEmail = async () => {
    let res = await getEmails(localStorage.access_token)
    if (res.data && res.data.status_code == 200) {
      setUserEmails(res.data?.data)
    }
  }

  let handleImagePreview = (index, type) => {
    setShow(true);
    setSelectedPreview(index);
    setAssetType(type);
  };

  // ---- Vehicle preview handlers ----
  const handleVehiclePreview = (src, name) => {
    if (!src) return;
    setVehiclePreviewSrc(src);
    setVehiclePreviewName(name || "Vehicle Image");
    setShowVehiclePreview(true);
  };

  const handleVehiclePreviewClose = () => {
    setShowVehiclePreview(false);
    setVehiclePreviewSrc(null);
    setVehiclePreviewName("");
  };

  const handleAttachmentClick = (index) => {
    if (areAssetsLocked) return;
    fileInputRefs.current[index]?.click();
  };
  const handleAdditionalAttachmentClick = (index) => {
    if (areAssetsLocked) return;
    additionalFileInputRefs.current[index]?.click();
  };

  let handleAddImg = (index) => {
    if (areAssetsLocked) return;
    let temp = [...assests];
    let obj = {
      id: index + 1,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      value: "",
      AssetID: null,
      AssetNo: "",
      Coming_From: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    };
    temp.push(obj);
    setAssets(temp);
  };

  let handleAddImgAdditional = (index) => {
    if (areAssetsLocked) return;
    let temp = [...additionalAsset];
    let obj = {
      id: index + 1,
      name: "S3S",
      img: "",
      imgName: "",
      imgPreview: "",
      ID: 0,
      value: "",
      from: "",
      AssetID: null,
      AssetNo: "",
      AssetBlob: "",
      Broken_AssetID: "",
      Broken_AssetNo: "",
      Broken_AssetBlob: "",
    };
    temp.push(obj);
    setAdditionalAsset(temp);
  };

  let handleRemoveImg = (val) => {
    if (areAssetsLocked) return;
    if (templateId) {
      handleDeleteAsset(val.ID)
      setAssets((prevAssets) => prevAssets.filter((item) => item.id !== val.id));
    } else {
      setAssets((prevAssets) => prevAssets.filter((item) => item.id !== val.id));
    }
  };


  let handleRemoveImgAdditional = (i, val) => {
    if (areAssetsLocked) return;
    if (templateId) {
      handleDeleteAsset(val.ID)
      let newPreview = selectedPreviewAdditional - 1;
      setSelectedPreviewAdditional(newPreview);
      let temp = [...additionalAsset];
      let arr = temp.filter((val, index) => i != index);
      setAdditionalAsset(arr);
    } else {
      let newPreview = selectedPreviewAdditional - 1;
      setSelectedPreviewAdditional(newPreview);
      let temp = [...additionalAsset];
      let arr = temp.filter((val, index) => i != index);
      setAdditionalAsset(arr);
    }

  };

  let handleDeleteAsset = async (id) => {
    let payload = { "ID": id }
    let token = localStorage.access_token
    setIsLoading(true)
    let res = await deleteAsset(payload, token)
    if (res && res.status == '200') {
      toast.success(res.data)
    }
    setIsLoading(false)
  }

  let handleRemoveImgPreview = (index, type) => {
    if (areAssetsLocked) return;
    if ((type = "1")) {
      let temp = [...assests];
      temp[index].img = "";
      temp[index].imgName = "";
      temp[index].imgPreview = "";
      temp[index].AssetBlob = "";
      setAssets(temp);
    } else {
      let temp = [...additionalAsset];
      temp[index].img = "";
      temp[index].imgName = "";
      temp[index].imgPreview = "";
      temp[index].AssetBlob = "";
      setAdditionalAsset(temp);
    }
  };

  let handleRemoveImgPreviewAdditional = (index) => {
    if (areAssetsLocked) return;
    let temp = [...additionalAsset];
    temp[index].img = "";
    temp[index].imgName = "";
    temp[index].imgPreview = "";
    setAdditionalAsset(temp);
  };

  // ============================================================
  //  handleFileChange — Image-only validation for assets
  // ============================================================
  const handleFileChange = async (event, index, type) => {
    if (areAssetsLocked) return;
    const file = event.target.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      event.target.value = ""; // allow re-selecting the same file later
      return;
    }

    if (type == "1") {
      let temp = [...assests];
      const fileUrl = URL.createObjectURL(file);
      temp[index].img = file;
      temp[index].imgName = file.name;
      temp[index].imgPreview = fileUrl;

      let data = await uploadFile(file, localStorage.access_token);
      temp[index].AssetBlob = data.data;
      setAssets(temp);
    } else {
      let temp = [...additionalAsset];
      const fileUrl = URL.createObjectURL(file);
      temp[index].img = file;
      temp[index].imgName = file.name;
      temp[index].imgPreview = fileUrl;

      let data = await uploadFile(file, localStorage.access_token);
      temp[index].AssetBlob = data.data;
      setAdditionalAsset(temp);
    }
  };

  const handleFileChangeAdditional = async (event, index) => {
    if (areAssetsLocked) return;
    const file = event.target.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      event.target.value = "";
      return;
    }

    let temp = [...additionalAsset];
    const fileUrl = URL.createObjectURL(file);
    temp[index].img = file;
    temp[index].imgName = file.name;
    let data = await uploadFile(file, localStorage.access_token);
    temp[index].AssetBlob = data.data;
    setAdditionalAsset(temp);
  };

  let uploadFile = async (file) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", file, file.name);
    let res = await uploadImg(formData, localStorage.access_token);
    setIsLoading(false);
    return res;
  };
  const handleDivClick = (val) => {
    if (isLocked) return;
    val.current.click();
  };

  // ============================================================
  //  handleVehicleFileChange — Image-only validation for vehicles
  // ============================================================
  const handleVehicleFileChange = async (event, val) => {
    if (isLocked) return;
    const file = event?.target?.files?.[0] || event?.files?.[0];
    if (!file) return;

    // Strict image-only validation
    if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
      toast.error("Only image files (PNG, JPG, JPEG, WEBP, GIF) are allowed.");
      if (event && event.target) event.target.value = "";
      return;
    }

    const fileUrl = URL.createObjectURL(file);
    if (val == "vehicleFrontRef") {
      setVehicleFrontName(file.name)
      setVehicleFrontPreview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleFrontimage(data.data);
    } else if (val == "vehicleBackRef") {
      setVehicleBackName(file.name)
      setVehicleBackPreview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleBackimage(data.data);
    } else if (val == "vehicleSide1Ref") {
      setVehicleside1Preview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleside1image(data.data);
    } else {
      setVehicleside2Preview(fileUrl);
      let data = await uploadFile(file, localStorage.access_token);
      setVehicleside2image(data.data);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  let handleChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  let handleRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setTruckingToRig({
      ...truckingToRig,
      [name]: value,
    });
  };

  let handleAdditionalRigChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target;
    setAdditionaltruckingToRig({
      ...additionaltruckingToRig,
      [name]: value,
    });
  };

  let handleSubmit = async (type) => {
    if (isLocked) return;
    let filteredAsset = assests.map((item) => ({
      AssetID: item.AssetID,
      AssetNo: item.AssetNo,
      AssetBlob: item.AssetBlob,
      Coming_From: item.Coming_From,
      ID: item?.ID,
    }));
    let filteredArr = filteredAsset.filter(
      (item) => item.AssetID != null && item.AssetID !== ""
    );

    const requiredFields = [
      { label: "Rig/Jobsite Number", value: formData.rigNuber },
      { label: "From Basin/Laydown-Yard", value: formData.laydown },
      { label: "Asset", value: filteredArr.length },
      { label: "Trucking Company", value: truckingToRig.company },
      { label: "Driver Name", value: truckingToRig.driverName },
      { label: "Phone Number", value: truckingToRig.phone },
    ];

    for (let field of requiredFields) {
      if (
        field.value == null ||
        (typeof field.value === "string" && field.value.trim() === "") ||
        (typeof field.value === "number" && field.value === 0)
      ) {
        toast.warning(`Input ${field.label} field`);
        return;
      }
    }
    let payload = {
      RequestType: "ADD",
      Asset: filteredArr,
      AdditionalAsset: [],
      BrokenAsset: [
        {
          AssetID: "",
          AssetNo: "",
          AssetBlob: "",
        },
      ],
      Chargeback: [""],
      ShippedTo: formData.rigNuber,
      ShippedFrom: formData.laydown,
      ADDED_Because: formData.reason,
      ADDT_ShipTo: "",
      Company: truckingToRig.company,
      JobSiteNumber: formData.rigNuber,
      DriverName: truckingToRig.driverName,
      PhoneNumber: truckingToRig.phone,
      BOL: truckingToRig.bol,
      PayForTruck: truckingToRig.payforTruck,
      S3SPO: truckingToRig.po,
      ADDT_Company: additionaltruckingToRig.company,
      ADDT_DriverName: additionaltruckingToRig.driverName,
      ADDT_PhoneNumber: additionaltruckingToRig.phone,
      ADDT_BOL: additionaltruckingToRig.bol,
      ADDT_PayForTruck: additionaltruckingToRig.payforTruck,
      ADDT_S3SPO: additionaltruckingToRig.po,
      VehicleFrontBlob: vehicleFrontimage ? vehicleFrontimage : "",
      VehicleBackBlob: vehicleBackimage ? vehicleBackimage : "",
      VehicleSide1Blob: vehicleside1image ? vehicleside1image : "",
      VehicleSide2Blob: vehicleside2image ? vehicleside2image : "",
      RETURNED: "",
      ADDED_Jobsite: "",
      ModifiedByUser: localStorage.role ? localStorage.role : "",
      additional_email_recipients: [...additionalEmails, ...additionalEmailsList]
    };

    if (type == 'save') {
      setIsLoading(true);
      let res = await postDeploy(payload, localStorage.access_token);
      setIsLoading(false);

      if (res) {
        if (res.status === 200) {
          toast.success("Template data submitted!");
          setTimeout(() => {
            navigate("/dashboard");
          }, 2000);
        }
      } else {
        toast.error("Internal server error!");
      }
    } else {
      payload.RequestID = templateId
      payload.Note = formData.note
      // Asset data is read-only in edit mode; do not send it back in the update payload.
      delete payload.Asset
      payload.BrokenAsset = []
      payload.Chargeback = [{ id: 1, name: "" }]
      setIsLoading(true)
      let res = await updateRequest(payload, localStorage.access_token)
      setIsLoading(false)
      console.log(" res.statusText ", res.statusText)
      if (res && res.statusText == "OK") {
        toast.success(res.data)
      }
    }

  };

  let resetData = () => {
    setTruckingToRig({
      company: "",
      driverName: "",
      phone: "",
      bol: "",
      payforTruck: "",
      po: "",
    });

    setFormData({
      rigNuber: "",
      laydown: "",
    });

    setAssets([
      {
        id: 0,
        name: "S3S",
        img: "",
        imgName: "",
        imgPreview: "",
        value: "",
      },
    ]);
    setVehicleFrontPreview("");
    setVehicleBackPreview("");
    setVehicleside1Preview("");
    setVehicleside2Preview("");
  };

  const handleSelect = (selectedValue, index, type) => {
    if (areAssetsLocked) return;
    // If selectedValue is null/undefined/empty, clear the asset
    if (!selectedValue && selectedValue !== 0) {
      console.log('Clearing asset...');
      if (type == 1) {
        let temp = [...assests];
        temp[index].AssetID = null;
        temp[index].AssetNo = "";
        setAssets(temp);
      } else {
        let temp = [...additionalAsset];
        temp[index].AssetID = null;
        temp[index].AssetNo = "";
        setAdditionalAsset(temp);
      }
      return;
    }

    // Find the item - first by value, then by label
    let obj = partsList.find((val) => val.value == selectedValue);
    if (!obj) {
      obj = partsList.find((val) => val.label == selectedValue);
    }

    if (type == 1) {
      let temp = [...assests];
      if (!obj) {
        console.log('No matching object found!');
        return;
      }
      temp[index].AssetID = obj.value;
      temp[index].AssetNo = obj.label;
      setAssets(temp);
    } else {
      let temp = [...additionalAsset];
      if (!obj) return;
      temp[index].AssetID = obj.value;
      temp[index].AssetNo = obj.label;
      setAdditionalAsset(temp);
    }
  };

  let fetchParts = async () => {
    let res = await getParts(localStorage.access_token);
    let locationRes = await getLocations(localStorage.access_token)

    if (locationRes && locationRes.data) {
      setInputOptionList(locationRes.data.response_body)
    }
    let temp = [];
    if (res.data) {
      res.data.map((val) => {
        let obj = { value: val.AssetID, label: val.AssetNo };
        temp.push(obj);
      });
    }
    setPartsList(temp);
  };


  let handleInputSelect = (e, name) => {
    if (isLocked) return;
    setFormData({
      ...formData,
      [name]: e
    })
  }

  let validateEmail = (email) => {
    if (!email) {
      return false
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      return false
    } else {
      return true
    }
  }

  let handleAddEmail = () => {
    if (isLocked) return;
    let check = validateEmail(additionalEmail)
    if (!check) {
      setAdditionalEmailError("Enter valid email id")
    } else {
      let temp = [...additionalEmailsList]
      temp.push(additionalEmail)
      setAdditionalEmailsList(temp)
      setAdditionalEmail('')
    }
  }

  let handleRemoveEmail = (indexToRemove) => {
    if (isLocked) return;
    const filteredArr = additionalEmailsList.filter((_, index) => index !== indexToRemove);
    setAdditionalEmailsList(filteredArr)
  }

  let handleEmailListChange = (e) => {
    if (isLocked) return;
    let { name, value } = e.target
    setAdditionalEmail(value)
    setAdditionalEmailError('')
  }

  let handleAddEmailChange = (val) => {
    if (isLocked) return;
    if (additionalEmails.includes(val)) {
      let temp = additionalEmails.filter(ele => ele !== val)
      setAdditionalEmails(temp)
    } else {
      let temp = [...additionalEmails]
      temp.push(val)
      setAdditionalEmails(temp)
    }

  }


  let handleUpdate = async () => {
    if (isLocked) return;
    let payload = {
      "RequestID": templateId,
      "Note": formData.note
    }
    setIsLoading(true)
    let res = await updateRequest(payload)
    setIsLoading(false)
    console.log(" res.statusText ", res.statusText)
    if (res && res.statusText == "OK") {
      toast.success(res.data)
    }
  }

   const handleVehicleRemove = (key) => {
    if (isLocked) return;
    switch (key) {
      case "vehicleFrontRef":
        setVehicleFrontPreview(null);
        setVehicleFrontName(null);
        setVehicleFrontimage(null);
        break;
      case "vehicleBackRef":
        setVehicleBackPreview(null);
        setVehicleBackName(null);
        setVehicleBackimage(null);
        break;
      case "vehicleSide1Ref":
        setVehicleside1Preview(null);
        setVehicleside1image(null);
        break;
      case "vehicleSide2Ref":
        setVehicleside2Preview(null);
        setVehicleside2image(null);
        break;
      default:
        break;
    }
  };


  return (
    <div className="wrapper">
      {isLoading ? <FullScreenLoader></FullScreenLoader> : null}
      <Header />
      <div className="container-layout">
        <div className="heading-section">
          <Container fluid>
            <Row>
              <Col xs="12">
                <div class="d-flex flex-wrap align-items-center">
                  <h2 className="main-title-h">Email Templates</h2>
                  {
                    templateId ?
                      <div className="side-viewbutton-lyt ps-4">
                        {
                          status ?

                            status == 'Completed' ?
                              <span className="btn-cmn-yt-2 ms-2">Completed</span>
                              :
                              <span className="btn-cmn-yt-1">Request Submitted</span>
                            :
                            null

                        }

                      </div>
                      :
                      null
                  }

                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="email-section-area">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="email-tab-wapper">
                  <div id="">
                    {
                      templateId ? null : <div>
                        <SubHeader />
                      </div>
                    }


                    <div className="content-tab--layout">
                      <div className="tab-items--content">
                        <Card>
                          <Card.Header className="cardheader--wgt"><h3 className="heading-dep-small">{heading}</h3></Card.Header>
                          <CardBody>
                            <div className="email-shrt-disc">
                              <p className="text-black">Hello,</p>
                              <p>
                                The following assets, being shipped today, will
                                be{" "}
                                <span className="text-bold-highlight">
                                  ADDED
                                </span>{" "}
                                to Rig/Site#
                                <span
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                                <div className="d-inline-block mx-md-2 my-2">
                                  <input disabled={isLocked} value={formData.rigNuber} name="rigNuber" type="text" onChange={(e) => handleChange(e)} placeholder="Text input" class="form-select-value form-control" />
                                </div>
                                {" "}
                                (an existing S3S jobsite).   from Basin/Laydown-Yard   <span
                                  style={{ color: "red" }}
                                >
                                  *
                                </span>
                                <div className="d-inline-block mx-md-2 my-2 position-relative input-width-area dropdown-close-btn">
                                  <SearchableDropdown
                                    options={inputOptionList}
                                    onSelect={(e) =>
                                      handleInputSelect(
                                        e,
                                        "laydown"
                                      )
                                    }
                                    placeholder="Select..."
                                    disabled={isLocked}
                                    selectedValue={formData.laydown}
                                  />
                                  <span className="down-arrow-iconwt"><img src={downArrowIcon} /></span>
                                </div>
                              </p>
                            </div>
                            <div className="addition-level-mts">
                              <div className="container-wgtrow">
                                <Accordion defaultActiveKey="0">
                                  <Accordion.Item eventKey="0">
                                    <Accordion.Header className="heading-lbl-waps">Add additional email IDs: <span className="short-linetxt-hd"><i className="fas fa-exclamation-circle me-1"></i> BC Admins automatically receive all notifications for requests submitted through this application</span> </Accordion.Header>
                                    <Accordion.Body>
                                      <div className="wrapper-grid--colart">
                                        <Row>
                                          {
                                            userEmails && userEmails.map((val, i) => {
                                              return (
                                                <Col xs={12} md={4} lg={4}>
                                                  <div className="list-check-filed-wp">
                                                    <h3 className="main-head-lst">{val.key}</h3>
                                                    <ul className="mult-check-wps--emnt">
                                                      {
                                                        val.values && val.values.map((ele, index) => {
                                                          return (
                                                            <li className="list-checkwps-dep">
                                                              <input disabled={isLocked} checked={additionalEmails.includes(ele) ? true : false} onChange={() => handleAddEmailChange(ele)} type="checkbox" className="check-lst-wp" /><span className="label-lst-nvm">{ele}</span>
                                                            </li>
                                                          )
                                                        })
                                                      }

                                                    </ul>

                                                  </div>
                                                </Col>

                                              )
                                            })
                                          }
                                        </Row>
                                        <Row>
                                          <Col xs={12} md={6}>
                                            <div className="addition-field-requre">
                                              <div className="field-wps-mt">
                                                <label className="label-txt--add">Add the additional email ID <i></i> </label>
                                                <div className="position-relative d-flex">
                                                  <input disabled={isLocked} onChange={(e) => handleEmailListChange(e)} value={additionalEmail} name="additionalEmail" type="email" placeholder="Enter the Email ID" className="form-control control-addtion-wp" />

                                                  <button onClick={handleAddEmail} disabled={isLocked} className="add-btn-mt">ADD</button>
                                                  <span className="msg-icon-wtp"><img src={messageIcon} /></span>
                                                </div>
                                              </div>
                                              {
                                                additionalEmailError ? <p style={{ fontSize: '12px', color: 'red' }} >{additionalEmailError}</p> : null

                                              }
                                              <div className="list-add-ftm">
                                                <ul className="mult-lstmtv">
                                                  {
                                                    additionalEmailsList.length ?
                                                      additionalEmailsList.map((val, i) => {
                                                        return (
                                                          <li className="lst-bxwp"><span class="icon-check-wth"><img src={checkIcon} alt="icon" /></span>{val}{!isLocked && (<button className="btn border-0 p-0 btn-cross-adnt"><img onClick={() => handleRemoveEmail(i)} src={crossIconWeb} alt="icon" /></button>)}</li>

                                                        )
                                                      })
                                                      :
                                                      null

                                                  }
                                                </ul>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                </Accordion>
                              </div>
                            </div>
                            <Row>
                              <Col xs={12} md={6} className="card-space-bottom">
                                <Card className="card-stage-bg">
                                  <CardBody>
                                    <Row>
                                      <Col xs={12} md={6}>
                                        <Card className="mb-3 card-height-equal">
                                          <CardBody>
                                            <div className="emial-heading-wt">
                                              <h3 className="heading-yt-wp">
                                                Assets
                                              </h3>
                                            </div>
                                            {assests.map((val, index) => {
                                              return (
                                                <div
                                                  className="assets-add"
                                                  key={val.id}
                                                >
                                                  {" "}
                                                  <div className="d-flex align-items-center column-wty mb-2">
                                                    <div className="left-select-value">
                                                      <SearchableDropdown
                                                        disabled={areAssetsLocked}
                                                        options={partsList}
                                                        onSelect={(e) =>
                                                          handleSelect(
                                                            e,
                                                            index,
                                                            "1"
                                                          )
                                                        }
                                                        placeholder="Search parts..."
                                                        selectedValue={val.AssetNo}
                                                      />
                                                      {index == 0 ? (
                                                        <span
                                                          className="require-dot-txt"
                                                          style={{ color: "red" }}
                                                        >
                                                          *
                                                        </span>
                                                      )
                                                        : null}
                                                    </div>
                                                    <>
                                                      {
                                                        !areAssetsLocked ?
                                                          <button
                                                            type="button"
                                                            className="btn btn-wt--comn"
                                                            onClick={() =>
                                                              handleAttachmentClick(index)
                                                            }
                                                          >
                                                            <img
                                                              src={attachmentIcon}
                                                              alt="icon"
                                                            />
                                                          </button>
                                                          :
                                                          null
                                                      }

                                                      {index == assests.length - 1 ? (
                                                        !areAssetsLocked ?
                                                          <button
                                                            onClick={() =>
                                                              handleAddImg(
                                                                index
                                                              )
                                                            }
                                                            type="button"
                                                            className="btn btn-wt--comn ms-1"
                                                          >
                                                            <img
                                                              src={plusIcon}
                                                              alt="icon"
                                                            />
                                                          </button>
                                                          :
                                                          null

                                                      ) :
                                                        (
                                                          !areAssetsLocked ?
                                                            <button
                                                              onClick={() =>
                                                                handleRemoveImg(
                                                                  val
                                                                )
                                                              }
                                                              type="button"
                                                              className="btn btn-wt--comn ms-1"
                                                            >
                                                              <img
                                                                src={deleteIcon}
                                                                alt="icon"
                                                              />
                                                            </button>
                                                            :
                                                            null
                                                        )
                                                      }
                                                    </>


                                                    {/* ==== Assets file input — image only ==== */}
                                                    <input
                                                      type="file"
                                                      accept={ALLOWED_IMAGE_ACCEPT}
                                                      ref={(el) =>
                                                      (fileInputRefs.current[
                                                        index
                                                      ] = el)
                                                      }
                                                      style={{ display: "none" }}
                                                      onChange={(e) =>
                                                        handleFileChange(
                                                          e,
                                                          index,
                                                          "1"
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div>
                                                  </div>
                                                  <div className="list-add-img">
                                                    <div className="list-imgadded-yt">
                                                      {val.imgName ? (
                                                        <div className="img-bx-wgt">
                                                          <img
                                                            className="place-img--emt"
                                                            src={placeholderImg}
                                                            alt=""
                                                          />
                                                          <span
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                            onClick={() =>
                                                              handleImagePreview(
                                                                index,
                                                                "1"
                                                              )
                                                            }
                                                            className="img-txt-name"
                                                          >
                                                            {val.imgName}
                                                          </span>
                                                          {
                                                            !areAssetsLocked ?
                                                              <>
                                                                <span
                                                                  onClick={() =>
                                                                    handleRemoveImgPreview(
                                                                      index,
                                                                      "2"
                                                                    )
                                                                  }
                                                                  className="cross-img-btn"
                                                                >
                                                                  <img
                                                                    src={crossIcon}
                                                                    alt=""
                                                                  />
                                                                </span>
                                                              </>
                                                              :
                                                              null
                                                          }

                                                        </div>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          </CardBody>
                                        </Card>
                                      </Col>
                                      <Col xs={12} md={6}>
                                        <Card className="mb-3 card-height-equal">
                                          <CardBody>
                                            <div className="mt-wap--gtr">
                                              <h3 className="heading-yt-wp">
                                                Trucking to Rig
                                              </h3>
                                              <div className="form-card--lyt">
                                                <Form>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Company{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="company"
                                                        value={
                                                          truckingToRig.company
                                                        }
                                                        type="text"
                                                        placeholder="Input Company"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Driver Name{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="driverName"
                                                        value={
                                                          truckingToRig.driverName
                                                        }
                                                        type="text"
                                                        placeholder="Input Name"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Phone Number{" "}
                                                      <span
                                                        style={{ color: "red" }}
                                                      >
                                                        *
                                                      </span>
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="phone"
                                                        value={truckingToRig.phone}
                                                        type="text"
                                                        placeholder="Input Phone"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Bill of Lading Number (BOL)
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="bol"
                                                        value={truckingToRig.bol}
                                                        type="text"
                                                        placeholder="Input BOL"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group
                                                    className="mb-3"
                                                    controlId=""
                                                  >
                                                    <Form.Label className="label-txt-vl">
                                                      Pay for the Truck{" "}
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="payforTruck"
                                                        value={
                                                          truckingToRig.payforTruck
                                                        }
                                                        type="text"
                                                        placeholder="Input Pay"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                  <Form.Group controlId="">
                                                    <Form.Label className="label-txt-vl">
                                                      S3S PO#{" "}
                                                    </Form.Label>
                                                    <div className="filed-group-control">
                                                      <Form.Control
                                                        disabled={isLocked}
                                                        onChange={handleRigChange}
                                                        name="po"
                                                        value={truckingToRig.po}
                                                        type="text"
                                                        placeholder="Input Po"
                                                        className="input-vt-text"
                                                      />
                                                    </div>
                                                  </Form.Group>
                                                </Form>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Card>
                                      </Col>
                                    </Row>
                                    <Row>
                                    </Row>
                                    <Row>
                                      <Col xs={12}>
                                        <p className="title-text-wgt text-start mt-2 mb-0">
                                          The assets were requested to be ADDED to
                                          the jobsite, because{" "}
                                          <Form.Control
                                            disabled={isLocked}
                                            onChange={(e) => handleChange(e)}
                                            name="reason"
                                            value={formData.reason}
                                            type="text"
                                            placeholder="Input here"
                                            className="input-val-txt my-1"
                                          />

                                        </p>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>

                                {additionalForm ? (
                                  <>
                                    <Card className="card-stage-bg mt-4">
                                      <CardBody className="pb-1">
                                        <Row>
                                          <Col xs={12} md={6}>
                                            <Card className="mb-3 card-height-equal">
                                              <CardBody className="px-2">
                                                <div className="emial-heading-wt px-3">
                                                  <h3 className="heading-yt-wp">
                                                    Additional Assets
                                                  </h3>
                                                </div>
                                                <div className="card-wgtwap">
                                                  {additionalAsset.map(
                                                    (val, index) => {
                                                      return (
                                                        <div className="assets-add">
                                                          <div className="d-flex align-items-center column-wty mb-2">
                                                            <div className="left-select-value">
                                                              <SearchableDropdown
                                                                options={partsList}
                                                                onSelect={(e) =>
                                                                  handleSelect(
                                                                    e,
                                                                    index,
                                                                    "2"
                                                                  )
                                                                }
                                                                placeholder="Search parts..."
                                                                disabled={areAssetsLocked}
                                                              />
                                                            </div>
                                                            {!areAssetsLocked && (
                                                              <button
                                                                type="button"
                                                                className="btn btn-wt--comn"
                                                                onClick={() =>
                                                                  handleAdditionalAttachmentClick(
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                <img
                                                                  src={attachmentIcon}
                                                                  alt="icon"
                                                                />
                                                              </button>
                                                            )}
                                                            {index ==
                                                              additionalAsset.length -
                                                              1 ? (
                                                              !areAssetsLocked ? (
                                                                <button
                                                                  onClick={() =>
                                                                    handleAddImgAdditional(
                                                                      index
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={plusIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              ) : null
                                                            ) : (
                                                              !areAssetsLocked ? (
                                                                <button
                                                                  onClick={() =>
                                                                    handleRemoveImgAdditional(
                                                                      index, val
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-wt--comn ms-1"
                                                                >
                                                                  <img
                                                                    src={deleteIcon}
                                                                    alt="icon"
                                                                  />
                                                                </button>
                                                              ) : null
                                                            )}

                                                            {/* ==== Additional asset input — image only ==== */}
                                                            <input
                                                              type="file"
                                                              accept={ALLOWED_IMAGE_ACCEPT}
                                                              ref={(el) =>
                                                              (additionalFileInputRefs.current[
                                                                index
                                                              ] = el)
                                                              }
                                                              style={{
                                                                display: "none",
                                                              }}
                                                              onChange={(e) =>
                                                                handleFileChange(
                                                                  e,
                                                                  index,
                                                                  "2"
                                                                )
                                                              }
                                                            />
                                                          </div>
                                                          <div className="list-add-img">
                                                            <div className="list-imgadded-yt">
                                                              {val.imgName ? (
                                                                <div className="img-bx-wgt">
                                                                  <img
                                                                    className="place-img--emt"
                                                                    src={
                                                                      placeholderImg
                                                                    }
                                                                    alt=""
                                                                  />
                                                                  <span
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                      handleImagePreview(
                                                                        index,
                                                                        "2"
                                                                      )
                                                                    }
                                                                    className="img-txt-name"
                                                                  >
                                                                    {val.imgName}
                                                                  </span>
                                                                  {!areAssetsLocked && (
                                                                    <span
                                                                      onClick={() =>
                                                                        handleRemoveImgPreview(
                                                                          index,
                                                                          "2"
                                                                        )
                                                                      }
                                                                      className="cross-img-btn"
                                                                    >
                                                                      <img
                                                                        src={
                                                                          crossIcon
                                                                        }
                                                                        alt=""
                                                                      />
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              ) : null}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      );
                                                    }
                                                  )}
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Col>
                                          <Col xs={12} md={6}>
                                            <Card className="mb-3 card-height-equal">
                                              <CardBody>
                                                <div className="mt-wap--gtr">
                                                  <h3 className="heading-yt-wp">
                                                    Additional Trucking to Rig
                                                  </h3>
                                                  <div className="form-card--lyt">
                                                    <Form>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Company
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="company"
                                                          value={
                                                            additionaltruckingToRig.company
                                                          }
                                                          type="text"
                                                          placeholder="Input Company"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Driver Name
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="driverName"
                                                          value={
                                                            additionaltruckingToRig.driverName
                                                          }
                                                          type="text"
                                                          placeholder="Input Name"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Phone Number
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="phone"
                                                          value={
                                                            additionaltruckingToRig.phone
                                                          }
                                                          type="text"
                                                          placeholder="Input Phone"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Bill of Lading Number
                                                          (BOL)
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="bol"
                                                          value={
                                                            additionaltruckingToRig.bol
                                                          }
                                                          type="text"
                                                          placeholder="Input BOL"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group
                                                        className="mb-3"
                                                        controlId=""
                                                      >
                                                        <Form.Label className="label-txt-vl">
                                                          Pay for the Truck
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="payforTruck"
                                                          value={
                                                            additionaltruckingToRig.payforTruck
                                                          }
                                                          type="text"
                                                          placeholder="Input Pay"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                      <Form.Group controlId="">
                                                        <Form.Label className="label-txt-vl">
                                                          S3S PO#
                                                        </Form.Label>
                                                        <Form.Control
                                                          disabled={isLocked}
                                                          onChange={
                                                            handleAdditionalRigChange
                                                          }
                                                          name="po"
                                                          value={
                                                            additionaltruckingToRig.po
                                                          }
                                                          type="text"
                                                          placeholder="Input Po"
                                                          className="input-vt-text"
                                                        />
                                                      </Form.Group>
                                                    </Form>
                                                  </div>
                                                </div>
                                              </CardBody>
                                            </Card>
                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Card>
                                  </>
                                ) : null}
                              </Col>
                              <Col xs={12} md={6}>
                                <Attachments
                                  vehicleFrontRef={vehicleFrontRef}
                                  vehicleBackRef={vehicleBackRef}
                                  vehicleSide1Ref={vehicleSide1Ref}
                                  vehicleSide2Ref={vehicleSide2Ref}
                                  handleVehicleFileChange={handleVehicleFileChange}
                                  handleDivClick={handleDivClick}
                                  vehicleFrontPreview={vehicleFrontPreview}
                                  vehicleBackPreview={vehicleBackPreview}
                                  vehicleside1Preview={vehicleside1Preview}
                                  vehicleside2Preview={vehicleside2Preview}
                                  vehicleFrontName={vehicleFrontName}
                                  vehicleBackName={vehicleBackName}
                                  handleVehiclePreview={handleVehiclePreview}
                                  handleVehicleRemove={handleVehicleRemove}
                                  templateId={templateId}
                                  isLocked={isLocked}
                                />
                              </Col>
                            </Row>
                            <Row>

                            </Row>
                          </CardBody>
                        </Card>
                        <div className="bottom-submit-action">
                          <Row>

                            <Col xs={12} md={6}>
                              {
                                templateId && !isLocked ?
                                  <div className="note-content-text">
                                    <Form.Label style={{ color: '#092e56' }} className="label-txt-vl">
                                      Comment
                                    </Form.Label>
                                    <textarea
                                      rows={5}
                                      placeholder={templateId ? "Enter note" : "Text input"}
                                      disabled={isLocked}
                                      name="note"
                                      value={formData.note}
                                      onChange={(e) => handleChange(e)}
                                      className="form-select-value form-control"
                                    />

                                  </div>
                                  :
                                  null
                              }

                            </Col>

                            <Col xs={12} md={6}>
                              <div className="text-start text-md-end mt-3 mt-md-0">
                                {
                                  templateId && !isLocked ?
                                    <button
                                      onClick={() => handleSubmit('update')}
                                      type="submit"
                                      className="btn btn-submit-btn me-2"
                                    >
                                      Save
                                    </button>
                                    :
                                    null
                                }
                                {
                                  templateId ?
                                    (
                                      isAdmin && !isCompleted ?
                                        <button
                                          onClick={() => handleComplete()}
                                          type="submit"
                                          className="btn btn-submit-btn"
                                        >
                                          Mark as complete
                                        </button>
                                        :
                                        null

                                    )

                                    :
                                    <button
                                      onClick={() => handleSubmit('save')}
                                      type="submit"
                                      className="btn btn-submit-btn ms-2"
                                    >
                                      Submit
                                    </button>
                                }
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                      <div className="tab-items--content"></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>

      {/* =====================================================
          Assets Preview Modal — Improved UI
          ===================================================== */}
      <Modal
        show={show}
        size="lg"
        aria-labelledby="asset-preview-title"
        centered
        onHide={handleClose}
        contentClassName="asset-preview-modal-content"
        dialogClassName="asset-preview-modal-dialog"
        backdropClassName="asset-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="asset-preview-modal-header border-0"
        >
          <Modal.Title id="asset-preview-title" className="asset-preview-modal-title">
            <span className="asset-preview-title-icon">
              <i className="fas fa-file-image"></i>
            </span>
            <span className="asset-preview-title-text">
              {assetType == 1 ? "Asset Attachment" : "Additional Asset Attachment"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="asset-preview-modal-body">
          {(() => {
            const currentItem =
              assetType == 1
                ? assests[selectedPreview]
                : additionalAsset[selectedPreview];

            const previewSrc = currentItem?.imgPreview || "";
            const previewName = currentItem?.imgName || "Asset Image";

            return (
              <>
                <div className="asset-preview-image-wrapper">
                  {previewSrc ? (
                    <img
                      src={previewSrc}
                      alt={previewName}
                      className="asset-preview-image"
                    />
                  ) : (
                    <div className="asset-preview-empty">
                      <i className="fas fa-image fa-3x mb-3"></i>
                      <p>No image to preview</p>
                    </div>
                  )}
                </div>

                {previewSrc && (
                  <div className="asset-preview-footer">
                    <span className="asset-preview-filename" title={previewName}>
                      <i className="fas fa-paperclip me-2"></i>
                      {previewName}
                    </span>
                    <a
                      href={previewSrc}
                      download={previewName}
                      className="asset-preview-download-btn"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fas fa-download me-2"></i>
                      Download
                    </a>
                  </div>
                )}
              </>
            );
          })()}
        </Modal.Body>
      </Modal>

      {/* =====================================================
          Vehicle Preview Modal — Improved UI
          ===================================================== */}
      <Modal
        show={showVehiclePreview}
        size="lg"
        aria-labelledby="vehicle-preview-title"
        centered
        onHide={handleVehiclePreviewClose}
        contentClassName="vehicle-preview-modal-content"
        dialogClassName="vehicle-preview-modal-dialog"
        backdropClassName="vehicle-preview-backdrop"
      >
        <Modal.Header
          closeButton
          closeVariant="white"
          className="vehicle-preview-modal-header border-0"
        >
          <Modal.Title id="vehicle-preview-title" className="vehicle-preview-modal-title">
            <span className="vehicle-preview-title-icon">
              <i className="fas fa-image"></i>
            </span>
            <span className="vehicle-preview-title-text">
              {vehiclePreviewName || "Vehicle Image Preview"}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="vehicle-preview-modal-body">
          <div className="vehicle-preview-image-wrapper">
            {vehiclePreviewSrc ? (
              <img
                src={vehiclePreviewSrc}
                alt={vehiclePreviewName || "Vehicle preview"}
                className="vehicle-preview-image"
              />
            ) : (
              <div className="vehicle-preview-empty">
                <i className="fas fa-image fa-3x mb-3"></i>
                <p>No image to preview</p>
              </div>
            )}
          </div>

          {vehiclePreviewSrc && (
            <div className="vehicle-preview-footer">
              <span className="vehicle-preview-filename" title={vehiclePreviewName}>
                <i className="fas fa-paperclip me-2"></i>
                {vehiclePreviewName || "Vehicle Image"}
              </span>
              <a
                href={vehiclePreviewSrc}
                download={vehiclePreviewName || "vehicle-image"}
                className="vehicle-preview-download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-download me-2"></i>
                Download
              </a>
            </div>
          )}
        </Modal.Body>
      </Modal>

      <MobileFooter></MobileFooter>
    </div>
  );
}

export default Add;